
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3qsiv", function(module, exports) {

$parcel$export(module.exports, "authModal", () => $27e9c01bd182deb1$export$6d45efd61b289eb3);
$parcel$export(module.exports, "initAuthBar", () => $27e9c01bd182deb1$export$8ff9c1b1502a9c5d);
$parcel$export(module.exports, "ensureFreshSession", () => (parcelRequire("5IRmI")).ensureFreshSession);
/**
 * Custom authentication modal using Netlify GoTrue API
 * Provides sign-up and sign-in flows without relying on Netlify Identity widget
 */ 
var $gxv0g = parcelRequire("gxv0g");

var $5IRmI = parcelRequire("5IRmI");
class $27e9c01bd182deb1$export$330d86d02aad9520 {
    constructor(options = {}){
        this.apiUrl = options.apiUrl || (0, $gxv0g.GOTRUE_API_URL);
        this.mode = 'login'; // 'login' or 'signup'
        this.isLoading = false;
        this._onLoginCallbacks = [];
        this.setupDOM();
        this.attachListeners();
    }
    setupDOM() {
        const html = `
      <dialog class="auth-modal" id="auth-modal" aria-labelledby="auth-title">
        <div class="auth-modal-content">
          <div class="auth-modal-header">
            <h2 id="auth-title">Sign In</h2>
            <button class="auth-modal-close" id="auth-close" aria-label="Close">\u{2715}</button>
          </div>

          <!-- Tab switcher -->
          <div class="auth-tabs" role="tablist">
            <button class="auth-tab-btn auth-tab-btn--active" data-mode="login" role="tab" aria-selected="true">
              Sign In
            </button>
            <button class="auth-tab-btn" data-mode="signup" role="tab" aria-selected="false">
              Create Account
            </button>
          </div>

          <!-- Form -->
          <form id="auth-form" class="auth-form" novalidate>
            <div class="form-group">
              <label for="auth-email">Email</label>
              <input
                type="email"
                id="auth-email"
                name="email"
                required
                placeholder="your@email.com"
                autocomplete="email">
            </div>

            <div class="form-group">
              <label for="auth-password">Password</label>
              <input
                type="password"
                id="auth-password"
                name="password"
                required
                placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}"
                autocomplete="current-password">
            </div>

            <!-- Signup-only: confirm password -->
            <div class="form-group" id="confirm-password-group" hidden>
              <label for="auth-confirm">Confirm Password</label>
              <input
                type="password"
                id="auth-confirm"
                name="confirm"
                placeholder="\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}\u{2022}"
                autocomplete="new-password">
              <span class="form-hint" id="password-hint" hidden>Passwords don't match</span>
            </div>

            <button type="submit" class="btn btn-primary auth-submit-btn" id="auth-submit">
              Sign In
            </button>

            <p id="auth-error" class="auth-error" role="alert" aria-live="polite" hidden></p>
            <p id="auth-loading" class="auth-loading" hidden aria-live="polite">Loading\u{2026}</p>
            <p id="auth-success" class="auth-success" role="status" aria-live="polite" hidden></p>
          </form>

          <!-- Password reset link (login mode only) -->
          <p id="forgot-password-section" class="auth-forgot">
            <button type="button" id="forgot-password-btn" class="auth-link-btn">
              Forgot password?
            </button>
          </p>

          <!-- Sign-up info (signup mode only) -->
          <p id="signup-info" class="auth-info" hidden>
            We'll send a confirmation email. Check your inbox to verify your account.
          </p>
        </div>
      </dialog>
    `;
        document.body.insertAdjacentHTML('beforeend', html);
    }
    attachListeners() {
        const tabBtns = document.querySelectorAll('.auth-tab-btn');
        const form = document.getElementById('auth-form');
        const closeBtn = document.getElementById('auth-close');
        const forgotBtn = document.getElementById('forgot-password-btn');
        const passwordInputs = [
            document.getElementById('auth-password'),
            document.getElementById('auth-confirm')
        ];
        // Tab switching
        tabBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.switchMode(btn.dataset.mode);
            });
        });
        // Form submission
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
        // Real-time password match validation (signup only)
        passwordInputs.forEach((input)=>{
            input.addEventListener('input', ()=>{
                this.validatePasswordMatch();
            });
        });
        // Close button
        closeBtn.addEventListener('click', ()=>{
            this.close();
        });
        // Close on Escape key
        // Forgot password
        forgotBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            this.showPasswordReset();
        });
    }
    switchMode(mode) {
        this.mode = mode;
        const tabBtns = document.querySelectorAll('.auth-tab-btn');
        const title = document.getElementById('auth-title');
        const submitBtn = document.getElementById('auth-submit');
        const confirmGroup = document.getElementById('confirm-password-group');
        const forgotSection = document.getElementById('forgot-password-section');
        const signupInfo = document.getElementById('signup-info');
        const passwordHint = document.getElementById('password-hint');
        // Update tab styling and aria
        tabBtns.forEach((btn)=>{
            const isActive = btn.dataset.mode === mode;
            btn.classList.toggle('auth-tab-btn--active', isActive);
            btn.setAttribute('aria-selected', String(isActive));
        });
        if (mode === 'signup') {
            title.textContent = 'Create Account';
            submitBtn.textContent = 'Sign Up';
            confirmGroup.hidden = false;
            forgotSection.hidden = true;
            signupInfo.hidden = false;
            document.getElementById('auth-password').autocomplete = 'new-password';
        } else {
            title.textContent = 'Sign In';
            submitBtn.textContent = 'Sign In';
            confirmGroup.hidden = true;
            forgotSection.hidden = false;
            signupInfo.hidden = true;
            passwordHint.hidden = true;
            document.getElementById('auth-password').autocomplete = 'current-password';
        }
        // Clear form and messages
        document.getElementById('auth-form').reset();
        this.clearError();
        this.clearSuccess();
    }
    validatePasswordMatch() {
        if (this.mode !== 'signup') return;
        const password = document.getElementById('auth-password').value;
        const confirm = document.getElementById('auth-confirm').value;
        const hint = document.getElementById('password-hint');
        if (confirm && password !== confirm) hint.hidden = false;
        else hint.hidden = true;
    }
    async handleSubmit() {
        const email = document.getElementById('auth-email').value.trim();
        const password = document.getElementById('auth-password').value;
        const confirm = document.getElementById('auth-confirm').value;
        // Basic validation
        if (!email || !password) {
            this.showError('Email and password are required');
            return;
        }
        if (this.mode === 'signup' && !confirm) {
            this.showError('Please confirm your password');
            return;
        }
        if (this.mode === 'signup' && password !== confirm) {
            this.showError('Passwords do not match');
            return;
        }
        if (password.length < 6) {
            this.showError('Password must be at least 6 characters');
            return;
        }
        this.clearError();
        this.clearSuccess();
        const submitBtn = document.getElementById('auth-submit');
        const loadingEl = document.getElementById('auth-loading');
        submitBtn.disabled = true;
        loadingEl.hidden = false;
        this.isLoading = true;
        try {
            if (this.mode === 'signup') await this.signup(email, password);
            else await this.login(email, password);
        } catch (err) {
            this.showError(err.message);
        } finally{
            submitBtn.disabled = false;
            loadingEl.hidden = true;
            this.isLoading = false;
        }
    }
    async signup(email, password) {
        const response = await fetch(`${this.apiUrl}/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        });
        if (!response.ok) {
            const data = await response.json().catch(()=>({}));
            throw new Error(data.error_description || data.msg || 'Sign-up failed');
        }
        this.showSuccess('Account created! Check your email to confirm, then sign in.');
        // Switch back to login after a short delay so the user can sign in
        setTimeout(()=>{
            this.switchMode('login');
        }, 2000);
    }
    async login(email, password) {
        // GoTrue's /token endpoint is an OAuth 2.0 token endpoint and requires
        // application/x-www-form-urlencoded, NOT application/json.
        // Sending JSON causes a "unsupported grant_type" error because the server
        // cannot parse the grant_type field from a JSON body.
        const params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('username', email);
        params.append('password', password);
        const response = await fetch(`${this.apiUrl}/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString()
        });
        if (!response.ok) {
            const data = await response.json().catch(()=>({}));
            throw new Error(data.error_description || data.msg || 'Sign-in failed');
        }
        const data = await response.json();
        (0, $5IRmI.saveSession)({
            ...data,
            email: email
        });
        this.showSuccess('Signed in successfully!');
        // Dispatch a custom event so board.js (and any other listeners) can react
        // without a full page reload.
        window.dispatchEvent(new CustomEvent('auth-modal:login', {
            detail: {
                token: data.access_token,
                email: email,
                user: {
                    email: email,
                    token: data.access_token
                }
            }
        }));
        // Close modal after a short pause so the success message is readable
        setTimeout(()=>{
            this.close();
        }, 800);
    }
    showError(message) {
        const errorEl = document.getElementById('auth-error');
        errorEl.textContent = message;
        errorEl.hidden = false;
        document.getElementById('auth-success').hidden = true;
    }
    clearError() {
        const errorEl = document.getElementById('auth-error');
        errorEl.textContent = '';
        errorEl.hidden = true;
    }
    showSuccess(message) {
        const successEl = document.getElementById('auth-success');
        successEl.textContent = message;
        successEl.hidden = false;
        document.getElementById('auth-error').hidden = true;
    }
    clearSuccess() {
        const successEl = document.getElementById('auth-success');
        successEl.textContent = '';
        successEl.hidden = true;
    }
    async showPasswordReset() {
        // GoTrue recovery only exists as a widget flow, and the widget is no longer
        // on every page — it is 481ms of third-party download for something almost
        // no page view uses. Fetch it at the moment someone asks to reset, which is
        // the only moment it is needed.
        this.showError('');
        await (0, $gxv0g.loadIdentityWidget)();
        if (window.netlifyIdentity) {
            this.close();
            window.netlifyIdentity.open('recovery');
        } else // Blocked, offline, or the script failed. Same message as before.
        this.showError('To reset your password, visit the sign-in page and use "Forgot password" in the Netlify Identity dialog.');
    }
    open(initialMode = 'login') {
        this.switchMode(initialMode);
        /** @type {HTMLDialogElement} */ const dialog = document.getElementById('auth-modal');
        if (!dialog.open) dialog.showModal();
        // showModal() focuses the first focusable child, which is the close
        // button; the email field is where someone actually wants to start.
        document.getElementById('auth-email').focus();
    }
    close() {
        /** @type {HTMLDialogElement} */ const dialog = document.getElementById('auth-modal');
        if (dialog.open) dialog.close();
        document.getElementById('auth-form').reset();
        this.clearError();
        this.clearSuccess();
    }
    /**
   * Register a callback to run after a successful login.
   * The callback receives { token, email, user }.
   */ onLogin(fn) {
        window.addEventListener('auth-modal:login', (e)=>fn(e.detail));
    }
}
const $27e9c01bd182deb1$export$6d45efd61b289eb3 = new $27e9c01bd182deb1$export$330d86d02aad9520({
    apiUrl: (0, $gxv0g.GOTRUE_API_URL)
});
function $27e9c01bd182deb1$export$8ff9c1b1502a9c5d() {
    // Initialize the widget regardless of whether this page has auth-bar
    // markup — see initIdentityWidget() for why this has to run everywhere.
    (0, $gxv0g.initIdentityWidget)();
    const authBar = document.getElementById('auth-bar');
    const emailEl = document.getElementById('auth-bar-email');
    const logoutBtn = document.getElementById('auth-bar-logout');
    if (!authBar || !logoutBtn) return;
    const resolveUser = ()=>{
        const email = (0, $5IRmI.currentEmail)();
        return email ? {
            email: email
        } : null;
    };
    function applyUser(user) {
        if (user) {
            if (emailEl) emailEl.textContent = user.email;
            authBar.hidden = false;
        } else {
            if (emailEl) emailEl.textContent = '';
            authBar.hidden = true;
        }
    }
    // A token link can land on any page, not only the site root — the Netlify
    // email template is editable, and a confirmation link that silently does
    // nothing is a miserable thing to diagnose. Costs one hash check when there
    // is no token, which is every ordinary page view.
    (0, $gxv0g.loadIdentityWidgetIfTokenPresent)().then(()=>{
        if (window.netlifyIdentity) attachWidgetEvents();
    });
    // Initial render
    applyUser(resolveUser());
    // ── Netlify Identity widget events ────────────────────────────────────────
    // A function rather than a straight-line block, because the widget is now
    // loaded on demand and may arrive after this runs.
    function attachWidgetEvents() {
        const identity = window.netlifyIdentity;
        if (!identity) return;
        identity.on('init', (user)=>applyUser(user ? {
                email: user.email
            } : resolveUser()));
        identity.on('login', (user)=>applyUser({
                email: user.email
            }));
        identity.on('logout', ()=>{
            // The widget's own session is gone; clear the custom-modal one too.
            (0, $5IRmI.clearSession)();
            applyUser(null);
        });
    }
    attachWidgetEvents();
    // ── Custom auth-modal login event ─────────────────────────────────────────
    window.addEventListener('auth-modal:login', (e)=>{
        applyUser({
            email: e.detail.email
        });
    });
    // ── Sign-out button ───────────────────────────────────────────────────────
    logoutBtn.addEventListener('click', ()=>{
        const hadWidgetSession = Boolean(window.netlifyIdentity?.currentUser?.());
        (0, $5IRmI.signOut)();
        // With a widget session the 'logout' handler above repaints; without one
        // nothing else will, so do it here.
        if (!hadWidgetSession) applyUser(null);
    });
}

});
parcelRegister("5IRmI", function(module, exports) {

$parcel$export(module.exports, "saveSession", () => $42aa7516568c7dfb$export$ccdf34816785229e);
$parcel$export(module.exports, "clearSession", () => $42aa7516568c7dfb$export$7809a8af6f3e4c63);
$parcel$export(module.exports, "ensureFreshSession", () => $42aa7516568c7dfb$export$ff3ccb38c51a8d4);
$parcel$export(module.exports, "getToken", () => $42aa7516568c7dfb$export$257b2d10b709d8ef);
$parcel$export(module.exports, "isLoggedIn", () => $42aa7516568c7dfb$export$256a5a3564694cfc);
$parcel$export(module.exports, "currentEmail", () => $42aa7516568c7dfb$export$7f03c5bf75200892);
$parcel$export(module.exports, "signOut", () => $42aa7516568c7dfb$export$b0ac3a1c242cb1ea);
/**
 * session.js — the only module that touches the stored session.
 *
 * The site runs two auth systems side by side: the Netlify Identity widget, and
 * the custom sign-in modal, which keeps a GoTrue session in localStorage under
 * `gotrue.user`. Every consumer used to know about both and reach into
 * localStorage itself — the same twenty lines appeared in post-render.js,
 * board.js, gallery.js, app.js, post-composer.js and auth-modal.js, in five
 * variants. Two of them forgot to check `expires_at`.
 *
 * Now `gotrue.user` is written and read here and nowhere else. Phase 4
 * collapses the two systems into one, and only this file changes.
 */ 
var $gxv0g = parcelRequire("gxv0g");
/**
 * @typedef {object} StoredSession
 * @property {string} access_token
 * @property {string} [refresh_token]
 * @property {number} [expires_at]
 * @property {string} [email]
 */ const $42aa7516568c7dfb$var$KEY = 'gotrue.user';
/** Refresh this long before expiry, so a request can't land as the token dies. */ const $42aa7516568c7dfb$var$REFRESH_MARGIN_MS = 300000;
function $42aa7516568c7dfb$export$98ac845cefcbe7a() {
    try {
        const raw = localStorage.getItem($42aa7516568c7dfb$var$KEY);
        return raw ? JSON.parse(raw) : null;
    } catch  {
        return null;
    }
}
function $42aa7516568c7dfb$export$ccdf34816785229e({ access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, email: email }) {
    try {
        localStorage.setItem($42aa7516568c7dfb$var$KEY, JSON.stringify({
            access_token: access_token,
            refresh_token: refresh_token,
            expires_at: Date.now() + (expires_in || 3600) * 1000,
            email: email
        }));
    } catch  {
    // Storage unavailable — the session lives for this page only. Not fatal.
    }
}
function $42aa7516568c7dfb$export$7809a8af6f3e4c63() {
    try {
        localStorage.removeItem($42aa7516568c7dfb$var$KEY);
    } catch  {
    // Nothing to do; if we can't clear it we also couldn't have written it.
    }
}
/**
 * True when the stored session has an access token that hasn't expired.
 * Written as a type predicate so callers narrow `session` to non-null.
 *
 * @param {StoredSession | null} session
 * @returns {session is StoredSession}
 */ function $42aa7516568c7dfb$var$isLive(session) {
    if (!session?.access_token) return false;
    return !session.expires_at || session.expires_at > Date.now();
}
async function $42aa7516568c7dfb$export$ff3ccb38c51a8d4() {
    const session = $42aa7516568c7dfb$export$98ac845cefcbe7a();
    if (!session?.refresh_token) return;
    if (session.expires_at && session.expires_at - Date.now() > $42aa7516568c7dfb$var$REFRESH_MARGIN_MS) return;
    try {
        const body = new URLSearchParams({
            grant_type: 'refresh_token',
            refresh_token: session.refresh_token
        });
        const res = await fetch(`${(0, $gxv0g.GOTRUE_API_URL)}/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
        });
        if (!res.ok) throw new Error('refresh rejected');
        const data = await res.json();
        $42aa7516568c7dfb$export$ccdf34816785229e({
            access_token: data.access_token,
            refresh_token: data.refresh_token || session.refresh_token,
            expires_in: data.expires_in,
            email: session.email
        });
    } catch  {
        $42aa7516568c7dfb$export$7809a8af6f3e4c63();
    }
}
async function $42aa7516568c7dfb$export$257b2d10b709d8ef() {
    try {
        await $42aa7516568c7dfb$export$ff3ccb38c51a8d4();
        // The widget manages its own refresh, so prefer it when present.
        const widgetUser = window.netlifyIdentity?.currentUser?.();
        if (widgetUser) return await widgetUser.jwt();
        const session = $42aa7516568c7dfb$export$98ac845cefcbe7a();
        if ($42aa7516568c7dfb$var$isLive(session)) return session.access_token;
        if (session) $42aa7516568c7dfb$export$7809a8af6f3e4c63();
    } catch  {
    // Treated as signed out.
    }
    return null;
}
function $42aa7516568c7dfb$export$256a5a3564694cfc() {
    if (window.netlifyIdentity?.currentUser?.()) return true;
    const session = $42aa7516568c7dfb$export$98ac845cefcbe7a();
    return $42aa7516568c7dfb$var$isLive(session) && Boolean(session.email);
}
function $42aa7516568c7dfb$export$7f03c5bf75200892() {
    const widgetUser = window.netlifyIdentity?.currentUser?.();
    if (widgetUser?.email) return widgetUser.email;
    const session = $42aa7516568c7dfb$export$98ac845cefcbe7a();
    return $42aa7516568c7dfb$var$isLive(session) ? session.email ?? null : null;
}
function $42aa7516568c7dfb$export$b0ac3a1c242cb1ea() {
    try {
        window.netlifyIdentity?.currentUser?.() && window.netlifyIdentity.logout();
    } catch  {
    // Widget missing or already signed out.
    }
    $42aa7516568c7dfb$export$7809a8af6f3e4c63();
}

});


parcelRegister("36CJS", function(module, exports) {

$parcel$export(module.exports, "api", () => $242ffb627eb2b9b2$export$644d8ea042df96a6);
/**
 * api.js — every call to our own backend goes through here.
 *
 * The pattern this replaces appeared a dozen times: fetch a token by hand,
 * spread a conditional Authorization header, check `res.ok`, try to pull an
 * `error` field out of the body, fall back to a status code, throw. Each copy
 * got the error path slightly differently wrong — some surfaced
 * "Server error (403)" to the reader, some swallowed the response entirely.
 *
 * Endpoints are named here rather than spelled at call sites, so the routes are
 * listed in one place and the /api/v1 move didn't touch six files.
 */ 
var $5IRmI = parcelRequire("5IRmI");
class $242ffb627eb2b9b2$export$f2e832acab1bdd79 extends Error {
    constructor(status, message){
        super(message);
        this.name = 'ApiError';
        this.status = status;
    }
}
/**
 * Turn a failed response into an ApiError with the most useful message
 * available: the server's own text when it sent one, otherwise something
 * readable. The backend answers errors as `{ error }` (see netlify/lib/http).
 */ async function $242ffb627eb2b9b2$var$toError(res) {
    let message = '';
    try {
        message = (await res.json())?.error || '';
    } catch  {
    // Non-JSON error body — a proxy or platform error page.
    }
    if (!message) {
        if (res.status === 401) message = "Your session expired \u2014 sign in again";
        else if (res.status === 403) message = 'You do not have permission to do that';
        else if (res.status === 404) message = 'That is no longer available';
        else if (res.status >= 500) message = 'The server had a problem. Try again.';
        else message = `Request failed (${res.status})`;
    }
    return new $242ffb627eb2b9b2$export$f2e832acab1bdd79(res.status, message);
}
/**
 * @param {string} path
 * @param {object} [opts]
 * @param {'GET'|'POST'|'DELETE'} [opts.method]
 * @param {unknown} [opts.body]      Serialised as JSON when present.
 * @param {boolean} [opts.auth]      Attach a bearer token. Throws 401 if none.
 * @param {AbortSignal} [opts.signal]
 */ async function $242ffb627eb2b9b2$var$request(path, { method: method = 'GET', body: body, auth: auth = false, signal: signal } = {}) {
    const headers = {};
    if (auth) {
        const token = await (0, $5IRmI.getToken)();
        // Fail here rather than letting the server answer 401, so the caller gets
        // the same ApiError shape either way.
        if (!token) throw new $242ffb627eb2b9b2$export$f2e832acab1bdd79(401, 'Sign in to do that');
        headers.Authorization = `Bearer ${token}`;
    }
    if (body !== undefined) headers['Content-Type'] = 'application/json';
    let res;
    try {
        res = await fetch(path, {
            method: method,
            headers: headers,
            signal: signal,
            ...body !== undefined ? {
                body: JSON.stringify(body)
            } : {}
        });
    } catch (err) {
        if (err.name === 'AbortError') throw err;
        throw new $242ffb627eb2b9b2$export$f2e832acab1bdd79(0, 'You appear to be offline');
    }
    if (!res.ok) throw await $242ffb627eb2b9b2$var$toError(res);
    if (res.status === 204) return null;
    return res.json();
}
// ── Endpoints ────────────────────────────────────────────────────────────────
// Paths are /api/v1/*. The previous /api/* routes still resolve — the functions
// answer to both — so a page loaded from a stale cache keeps working.
const $242ffb627eb2b9b2$var$q = encodeURIComponent;
const $242ffb627eb2b9b2$export$644d8ea042df96a6 = {
    posts: {
        /** @param {PageOpts} [opts] */ list: ({ limit: limit, cursor: cursor, signal: signal } = {})=>$242ffb627eb2b9b2$var$request(`/api/v1/posts${$242ffb627eb2b9b2$var$pageQuery(limit, cursor)}`, {
                signal: signal
            }),
        create: (post)=>$242ffb627eb2b9b2$var$request('/api/v1/posts', {
                method: 'POST',
                body: post,
                auth: true
            }),
        remove: (id)=>$242ffb627eb2b9b2$var$request(`/api/v1/posts/${$242ffb627eb2b9b2$var$q(id)}`, {
                method: 'DELETE',
                auth: true
            }),
        comments: {
            list: (postId)=>$242ffb627eb2b9b2$var$request(`/api/v1/posts/${$242ffb627eb2b9b2$var$q(postId)}/comments`),
            create: (postId, body)=>$242ffb627eb2b9b2$var$request(`/api/v1/posts/${$242ffb627eb2b9b2$var$q(postId)}/comments`, {
                    method: 'POST',
                    body: {
                        body: body
                    },
                    auth: true
                }),
            remove: (postId, commentId)=>$242ffb627eb2b9b2$var$request(`/api/v1/posts/${$242ffb627eb2b9b2$var$q(postId)}/comments/${$242ffb627eb2b9b2$var$q(commentId)}`, {
                    method: 'DELETE',
                    auth: true
                })
        },
        toggleLike: (postId)=>$242ffb627eb2b9b2$var$request(`/api/v1/posts/${$242ffb627eb2b9b2$var$q(postId)}/likes`, {
                method: 'POST',
                auth: true
            })
    },
    me: {
        likes: ()=>$242ffb627eb2b9b2$var$request('/api/v1/me/likes', {
                auth: true
            })
    },
    board: {
        threads: {
            /** @param {PageOpts} [opts] */ list: ({ limit: limit, cursor: cursor } = {})=>$242ffb627eb2b9b2$var$request(`/api/v1/board/threads${$242ffb627eb2b9b2$var$pageQuery(limit, cursor)}`),
            create: (thread)=>$242ffb627eb2b9b2$var$request('/api/v1/board/threads', {
                    method: 'POST',
                    body: thread,
                    auth: true
                }),
            remove: (id)=>$242ffb627eb2b9b2$var$request(`/api/v1/board/threads/${$242ffb627eb2b9b2$var$q(id)}`, {
                    method: 'DELETE',
                    auth: true
                })
        },
        replies: {
            list: (threadId)=>$242ffb627eb2b9b2$var$request(`/api/v1/board/threads/${$242ffb627eb2b9b2$var$q(threadId)}/replies`),
            create: (threadId, reply)=>$242ffb627eb2b9b2$var$request(`/api/v1/board/threads/${$242ffb627eb2b9b2$var$q(threadId)}/replies`, {
                    method: 'POST',
                    body: reply,
                    auth: true
                }),
            remove: (threadId, replyId)=>$242ffb627eb2b9b2$var$request(`/api/v1/board/threads/${$242ffb627eb2b9b2$var$q(threadId)}/replies/${$242ffb627eb2b9b2$var$q(replyId)}`, {
                    method: 'DELETE',
                    auth: true
                })
        }
    },
    gallery: {
        /** @param {PageOpts} [opts] */ list: ({ limit: limit, cursor: cursor } = {})=>$242ffb627eb2b9b2$var$request(`/api/v1/gallery${$242ffb627eb2b9b2$var$pageQuery(limit, cursor)}`),
        add: (item)=>$242ffb627eb2b9b2$var$request('/api/v1/gallery', {
                method: 'POST',
                body: item,
                auth: true
            }),
        remove: (id)=>$242ffb627eb2b9b2$var$request(`/api/v1/gallery/${$242ffb627eb2b9b2$var$q(id)}`, {
                method: 'DELETE',
                auth: true
            })
    },
    uploads: {
        signature: ()=>$242ffb627eb2b9b2$var$request('/api/v1/uploads/signature', {
                method: 'POST',
                auth: true
            })
    }
};
function $242ffb627eb2b9b2$var$pageQuery(limit, cursor) {
    if (!limit) return '';
    const params = new URLSearchParams({
        limit: String(limit)
    });
    if (cursor) params.set('cursor', cursor);
    return `?${params}`;
}

});


//# sourceMappingURL=app.e0278e2b.js.map
